var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Route } from 'react-router-dom';
import { DefaultAuthorizationError } from './DefaultAuthorizationError';
import { LoadingPage } from './LoadingPage';
import { useRoles } from './RoleContext';
import { getUnauthorizedRoles } from './utils';
/**
 * This component makes sure the user has the necessary roles to see the content.
 */
export var AuthorizedRoute = function (_a) {
    var Component = _a.component, _b = _a.authorizationErrorComponent, AuthorizationErrorComponent = _b === void 0 ? DefaultAuthorizationError : _b, _c = _a.authorizedRoles, authorizedRoles = _c === void 0 ? [] : _c, _d = _a.authorizationRule, authorizationRule = _d === void 0 ? 'and' : _d, rest = __rest(_a, ["component", "authorizationErrorComponent", "authorizedRoles", "authorizationRule"]);
    var _e = useRoles(), isLoading = _e.isLoading, roles = _e.roles;
    if (isLoading)
        return React.createElement(Route, __assign({}, rest, { component: LoadingPage }));
    var unauthorizedRoles = getUnauthorizedRoles(roles, authorizedRoles, authorizationRule);
    if (unauthorizedRoles.length) {
        return (React.createElement(Route, __assign({}, rest, { component: function (props) { return (React.createElement(AuthorizationErrorComponent, __assign({}, props, { unauthorizedRoles: unauthorizedRoles }))); } })));
    }
    return React.createElement(Route, __assign({}, rest, { component: Component }));
};
//# sourceMappingURL=AuthorizedRoute.js.map